import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { CREDIT_SECURITY_TYPES, PRODUCT_TYPES } from 'constants/dictionaries';

import { mapDictionary } from '../lib/mapDictionary';
import type { IOffersFiltersState, TOffersFiltersIncomingDictionaries } from '../types';

const initialState: IOffersFiltersState = {
  form: {
    creditSecurityType: CREDIT_SECURITY_TYPES[0],
    productTypes: PRODUCT_TYPES.map((item) => item.value),
  },
  dictionaries: {
    purposes: [],
    securityTypes: [],
    productTypes: [],
  },
};

export const offersFiltersSlice = createSlice({
  name: 'offersFilters',
  initialState,
  reducers: {
    setFilters: (state, { payload }: PayloadAction<Partial<IOffersFiltersState['form']>>) => {
      state.form = {
        ...state.form,
        ...payload,
      };
    },
    setFiltersDictionaries: (state, { payload }: PayloadAction<Partial<TOffersFiltersIncomingDictionaries>>) => {
      const { purposes, productTypes, securityTypes } = mapDictionary(payload);

      state.dictionaries = {
        ...state.dictionaries,
        purposes,
        productTypes,
        securityTypes,
      };
    },
  },
});

export const { setFilters, setFiltersDictionaries } = offersFiltersSlice.actions;
